<div>
	@if(professionalPackages()){
		@for (item of [].constructor(totalProfessionalPackages() > maxShownPackages ? maxShownPackages : totalProfessionalPackages() ); track $index) {
			<span [ngClass]="{
				'pending': $index >= professionalPackages().next,
				'closed': $index < professionalPackages().next
			}"></span>
		}
		@if(totalProfessionalPackages() > maxShownPackages){
			<span class="centered-text">...</span>
		}
	}@else {
		<!-- Pre-Aligner Indicator-->
		<fa-layers>
			@if(hasPreAlignerSalesOrder()){
				<fa-icon class="light-green" [icon]="faCircle" [size]="'sm'"></fa-icon>
			}
			<fa-icon [ngClass]="{
				'closed': hasPreAlignerSalesOrder()
			}"
			[icon]="faCircleParking" [size]="'sm'"></fa-icon>
		</fa-layers>
		@if(functionALPackages()){
			<!-- Closed packages -->
			@for (closed_package of functionALPackages().closed; track $index) {
				<span class="closed"></span>
			}
			<!-- Active package -->
			@if(functionALPackages().active){
				<span class="active"></span>
			}
			<!-- Pending packages -->
			@for (pending_package of functionALPackages().pending; track $index) {
				<span class="pending"></span>
			}
		}
	}
</div>
